





















import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseIcon from "@/components/BaseIcon";
import { ProcessedContentFiles } from "@/components/ContentFeedItem";
import PostFileList from "@/components/PostFileList";
import ContentFeedLocked from "../ContentFeedLocked";

@Component({
  name: "ContentFeedFileList",
  components: { ContentFeedLocked, PostFileList, BaseIcon },
})
export default class ContentFeedFileList extends mixins(WithAuthUser) {
  @Prop({ type: Object, required: true })
  public readonly fileList!: ProcessedContentFiles;

  public showAllFiles = false;

  public get filesToPrint() {
    return this.showAllFiles ? this.fileList.accessed : this.fileList.accessed.slice(0, 3);
  }

  public getDownloadUrl(file: ContentFile) {
    return MediaFilesController.getFileUrl(file.urlPart);
  }

  public get showUnlock() {
    return this.fileList.locked.length > 0 && (this.showAllFiles || this.fileList.accessed.length <= 3);
  }
}
